import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core';
import { FormattedMessage } from 'react-intl';

// Confirm-save guard shown when an admin (impersonating a user) saves a profile,
// to minimise the risk of accidental changes (STU-17). title/body/confirmLabel
// let the same dialog carry other confirmations; they default to the
// impersonation copy so that caller is unchanged.
const ConfirmSaveDialog = ({
  open,
  onClose,
  onConfirm,
  title,
  body,
  confirmLabel,
  titleId = 'confirm-save-title',
}) => (
  <Dialog open={open} onClose={onClose} aria-labelledby={titleId}>
    <DialogTitle id={titleId}>
      {title || <FormattedMessage id="profile.confirmSave.title" defaultMessage="Save changes?" />}
    </DialogTitle>
    <DialogContent>
      <DialogContentText>
        {body || (
          <FormattedMessage
            id="profile.confirmSave.body"
            defaultMessage="Save the changes to this user's profile?"
          />
        )}
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} color="primary">
        <FormattedMessage id="profile.confirmSave.cancel" defaultMessage="Cancel" />
      </Button>
      <Button onClick={onConfirm} color="primary" variant="contained" autoFocus>
        {confirmLabel || (
          <FormattedMessage id="profile.confirmSave.confirm" defaultMessage="Save" />
        )}
      </Button>
    </DialogActions>
  </Dialog>
);

ConfirmSaveDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  title: PropTypes.node,
  body: PropTypes.node,
  confirmLabel: PropTypes.node,
  // Two of these can be mounted at once while one fades out; keep the ids apart.
  titleId: PropTypes.string,
};

export default ConfirmSaveDialog;
